module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-362.167a94c.woff2";